module.exports = __webpack_public_path__ + "static/img/ALBB_H5.5c718ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/ALBB_H5.png
// module id = YO82
// module chunks = 34